import { render } from "./FadeVue.vue?vue&type=template&id=af73910a"
import script from "./FadeVue.vue?vue&type=script&lang=js"
export * from "./FadeVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__